import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore, useSessionStore, useSitesStore } from "@/stores";
import IStockHistory from "@/models/responses/IStockHistory";
import StockHistory from "@/models/frontend/StockHistory";

export const useStockHistoryStore = defineStore("stockHistory", {
  state: () => ({
    error: "" as any,
    data: <StockHistory>{},
  }),
  actions: {
    async fetchAll(historyDays: number) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);
      if (!isAuthenticated.value) return;

      const sessionStore = useSessionStore();
      const { selectedSiteId } = storeToRefs(sessionStore);

      this.error = "";
      let url = "v1.0/stock-history";
      if (selectedSiteId.value > 0) {
        url = "v1.0/stock-history/" + selectedSiteId.value;
      }
      await api
        .get<IStockHistory>(url, { params: { historyDays: historyDays }})
        .then((response) => (this.data = this.mapToFrontend(response.data)))
        .catch((error) => (this.error = error));
    },
    mapToFrontend(stockHistory: IStockHistory) {
      const sitesStore = useSitesStore();
      const site = sitesStore.getById(stockHistory.siteId);
      return new StockHistory(
        site,
        stockHistory.itemStockHistory
      );
    }
  },
});
